import React from "react";
import "../mspsettingsv2.scss"
import DisabledButtonWithToolTip from "../../Theme/DisabledButtonWithToolTip";
import { Button } from "react-bootstrap";
import { NO_ACCESS_TEXT } from "../../App/App";
import TooltipWrapper from "../../TooltipWrapper/TooltipWrapper";

const HeaderWithAddButton = ({
  header = '',
  children,
  buttonLabel = 'Add',
  isDisable = false,
  isTooltipDisabled=true,
  tooltipText='',
  onButtonClick = () => { },
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
      {children ? children : <div className="f-500">{header}</div>}
      <div>
        {isDisable ? (
          <DisabledButtonWithToolTip buttonText={"Add access roles"} noAccessText={NO_ACCESS_TEXT} />
        ) : (
          <TooltipWrapper textAlign={"left"} disabled={isTooltipDisabled} content={tooltipText}>
            <Button className="d-flex align-items-center add-member-btn" disabled={!isTooltipDisabled} onClick={onButtonClick}>
              <img src="/images/attack-surface/white-plus-icon.svg" alt="" className="mr-2" />
              {buttonLabel}
            </Button>
          </TooltipWrapper>
        )}
      </div>
    </div>
  );
};

export default HeaderWithAddButton;
